import { render, staticRenderFns } from "./WBFeedback.vue?vue&type=template&id=30af71a3&"
import script from "./WBFeedback.vue?vue&type=script&lang=js&"
export * from "./WBFeedback.vue?vue&type=script&lang=js&"
import style0 from "./WBFeedback.vue?vue&type=style&index=0&id=30af71a3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports